const pageArrowsConfig = {
	articleResultList: {
		getParams: elem => {
			if (!elem) return;
			return {
				ds: elem.dataset.ds,
				pageNumber: elem.dataset.pageNumber,
				pageSize: elem.dataset.pageSize,
				dateSort: elem.dataset.dateSort,
				filtersToApply: elem.dataset.filtersToApply
			};
		}
	},
	littleThingsResultList: {
		getParams: elem => {
			if (!elem) return;
			return {
				ds: elem.dataset.ds,
				page: elem.dataset.pageNumber,
				pagesize: elem.dataset.pageSize,
				language: elem.dataset.language
			};
		}
	}
};

export default pageArrowsConfig;
